import React from "react";
import { Tabs, Tab } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation, useHistory } from "react-router-dom";
import ClientSettlementsReport from "./ClientSettlementsReport";
import TeacherPayrollReport from "./TeacherSettlementsReport";

function SettlementsReport(props) {
  const { t: tr } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const searchParams = new URLSearchParams(location.search);
  const activeTab = searchParams.get("tab") === "teachers" ? "teachers" : "clients";

  const handleSelect = (key) => {
    searchParams.set("tab", key);
    history.replace({
      pathname: location.pathname,
      search: searchParams.toString(),
      state: location.state,
    });
  };

  return (
    <div className="mb-5 mt-2">
      <Tabs activeKey={activeTab} onSelect={handleSelect} id="settlements-report-tabs" className="mb-4">
        <Tab eventKey="clients" title={tr("billing:clientSettlements_109")}>
          {activeTab === "clients" && <ClientSettlementsReport {...props} />}
        </Tab>
        <Tab eventKey="teachers" title={tr("billing:teacherPayroll.title")}>
          {activeTab === "teachers" && <TeacherPayrollReport {...props} />}
        </Tab>
      </Tabs>
    </div>
  );
}

export default SettlementsReport;
